import {
  useActivateCampaigns,
  useArchiveCampaigns,
} from 'scenes/Campaigns/GGCampaigns/data/mutations';
import { useCopyLink } from 'scenes/Campaigns/hooks';

import { CampaignActions as Actions } from './CampaignActions';

export const CampaignActions = ({
  data,
  onGenerateLinks,
  onEdit,
  onDuplicate,
  onMoveToAnotherAffiliate,
  onArchive,
  onActivate,
  ...props
}) => {
  const { id, name, link, deeplink } = data || {};
  const trackingLink = deeplink?.link || link;

  const [archiveCampaigns] = useArchiveCampaigns();
  const [activateCampaigns] = useActivateCampaigns();

  const copyLink = useCopyLink();
  const handleCopy = () => copyLink(trackingLink);
  const handleGenerate = () => onGenerateLinks(data);
  const handleEdit = () => onEdit(data);
  const handleDuplicate = () => onDuplicate(data);
  const handleMoveToAnotherAffiliate = () =>
    onMoveToAnotherAffiliate({ id, name });

  const handleArchive = async () =>
    await archiveCampaigns({ status: 1, campaigns: [{ id, name }] });
  const handleActivate = async () =>
    await activateCampaigns({ status: 0, campaigns: [{ id, name }] });

  return (
    <Actions
      {...props}
      onCopy={handleCopy}
      onGenerateLinks={handleGenerate}
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      onMoveToAnotherAffiliate={handleMoveToAnotherAffiliate}
      onArchive={handleArchive}
      onActivate={handleActivate}
    />
  );
};
